import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ClientNode, LeadNode, LeadStatusType } from '@generated/graphql';

@Component({
  selector: 'search-client-row',
  templateUrl: './search-client-row.component.html',
  styleUrls: ['./search-client-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchClientRowComponent {
  LeadStatusType = LeadStatusType;

  @Input() item: ClientNode | LeadNode;
  @Output() assignLead = new EventEmitter();

  // The row is also rendered inside a routerLink anchor (my-leads-block), so the
  // click must not bubble up and navigate instead of opening the assign modal.
  onAssignClick(event: MouseEvent) {
    event.stopPropagation();
    event.preventDefault();
    this.assignLead.emit();
  }
}
